module.exports = __webpack_public_path__ + "static/media/IntroOverview.5b7a89dd.svg";